import moment from "moment"
import i18n from '@/lang/i18n'

// All Charts
// Attributes Charts
export default {
    methods: {
        formatNumber(num) {
            switch (true) {
                case num >= 1000000:
                    return `${parseFloat((num / 1000000).toFixed(1))}M`
                case num >= 100000:
                    return `${(num / 1000).toFixed(0)}k`
                case num >= 1000:
                    return `${parseFloat((num / 1000).toFixed(1))}k`
                default:
                    return num
            }
        },
        formatDuration(seconds, largest, precision = 0) {
            // Detectar el locale actual de i18n
            const locale = i18n.global.locale.value || 'en'
            // Sufijos por idioma
            const suffixes = {
                y: (locale === 'es' || locale === 'pt') ? 'a' : 'y',
                M: 'M', // meses
                d: 'd',
                h: 'h',
                m: 'm',
                s: 's',
            }
            if (largest === 1) {
                const duration = moment.duration(seconds, 'seconds')
                const units = [
                    {
                        key: 'y',
                        value: duration.years() + duration.months() / 12 + duration.days() / 365
                            + duration.hours() / 8760 + duration.minutes() / 525600 + duration.seconds() / 31536000,
                    },
                    {
                        key: 'M',
                        value: duration.months() + duration.days() / 30
                            + duration.hours() / 720 + duration.minutes() / 43200 + duration.seconds() / 2592000,
                    },
                    { key: 'd', value: duration.days() + duration.hours() / 24 + duration.minutes() / 1440 + duration.seconds() / 86400 },
                    { key: 'h', value: duration.hours() + duration.minutes() / 60 + duration.seconds() / 3600 },
                    { key: 'm', value: duration.minutes() + duration.seconds() / 60 },
                    { key: 's', value: duration.seconds() },
                ]
                // Buscar la unidad mayor con valor >= 1
                const major = units.find((u) => u.value >= 1) || units[units.length - 1]
                const decimals = precision || 1
                return `${major.value.toFixed(decimals)}${suffixes[major.key]}`
            }
            return moment.duration(seconds, 'seconds').format(
`y[${suffixes.y}] M[${suffixes.M}] d[${suffixes.d}] h[${suffixes.h}]:m[${suffixes.m}]:s[${suffixes.s}]`,
{ largest, precision },
            )
        },
        formatSeconds(seconds, rangeDur) {
            let dur = 0
            switch (rangeDur) {
                case 'days':
                    dur = moment.duration(seconds, 'seconds').asDays()
                    break
                case 'hours':
                    dur = moment.duration(seconds, 'seconds').asHours()
                    break
                case 'minutes':
                    dur = moment.duration(seconds, 'seconds').asMinutes()
                    break
                default:
                    dur = seconds
            }
            return dur
        },
        rangeDuration(seconds) {
            let rangeDur = ''
            switch (true) {
                case seconds >= 60 * 60 * 24:
                    rangeDur = 'days'
                    this.range = 'd'
                    break
                case seconds >= 60 * 60:
                    rangeDur = 'hours'
                    this.range = 'h'
                    break
                case seconds >= 60:
                    rangeDur = 'minutes'
                    this.range = 'm'
                    break
                default:
                    rangeDur = 'seconds'
                    this.range = 's'
            }
            return rangeDur
        },
        lineBreak(inputString) {
            let resultado = ''
            for (let i = 0; i < inputString.length; i += 22) {
                const linea = inputString.substr(i, 22)
                resultado += `${linea }<br>`
            }
            return resultado
        },
    },
}
